import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import ListSubItem from '../ListSubItem';
import { ListSubItemTextProps } from '../ListSubItemText';

import { Body1 } from '../Typography';

import styles from './index.module.scss';

export interface ListItemTextWithLinkProps {
  text: string;
  icon: JSX.Element;
  link: string;
  linkText: string;
  subItems?: ListSubItemTextProps[];
}

const ListItemTextWithLink: React.FC<ListItemTextWithLinkProps> = ({
  text,
  icon,
  link,
  linkText,
  subItems,
}) => {
  const intl = useIntl();

  const url = intl.formatMessage({
    id: link,
  });
  return (
    <>
      <div className={styles.wrapper}>
        {icon}

        <Body1 className={styles.item}>
          {
            <FormattedMessage
              id={text}
              values={{
                strong: (chunks: any) => <strong>{chunks}</strong>,
                br: <span className={styles.customBreak} />,
                link: (
                  <a
                    className={styles.link}
                    href={url}
                    target='_blank'
                    rel='noreferrer'
                  >
                    <FormattedMessage id={linkText} />
                  </a>
                ),
              }}
            />
          }
        </Body1>
      </div>
      {subItems && subItems.length > 0 && (
        <ListSubItem subItems={subItems} className={styles.subItems} />
      )}
    </>
  );
};

export default ListItemTextWithLink;
